import React from 'react';
import { motion } from 'framer-motion';
import { Globe, Ship, Boxes, Store, Sparkles, Tag, ArrowRight, Building2, ShoppingBag } from 'lucide-react';
import { generateGeneralWhatsAppLink } from '../data/products';

const iconMap = {
  Globe: Globe,
  Ship: Ship,
  Boxes: Boxes,
  Store: Store,
  Sparkles: Sparkles,
  Tag: Tag,
  Building: Building2,
  ShoppingBag: ShoppingBag
};

const BuyerCard = ({ item, index = 0 }) => {
  const IconComponent = iconMap[item.icon] || Globe;

  return (
    <motion.div
      initial={{ opacity: 0, y: 35 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-40px' }}
      transition={{ duration: 0.5, delay: index * 0.1, ease: [0.22, 1, 0.36, 1] }}
      whileHover={{ y: -8 }}
      className="glass-panel card-hover-effect"
      style={{
        padding: '32px 28px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
        overflow: 'hidden'
      }}
    >
      {/* Accent corner indicator */}
      <div
        style={{
          position: 'absolute',
          top: 0,
          right: 0,
          width: '60px',
          height: '60px',
          background: 'radial-gradient(circle at top right, rgba(224, 0, 135, 0.15) 0%, transparent 70%)',
          pointerEvents: 'none'
        }}
      />

      <div>
        <div
          style={{
            width: '52px',
            height: '52px',
            borderRadius: '12px',
            background: 'rgba(224, 0, 135, 0.08)',
            border: '1px solid rgba(224, 0, 135, 0.25)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--accent-magenta)',
            marginBottom: '20px',
            boxShadow: '0 4px 12px rgba(224, 0, 135, 0.12)'
          }}
        >
          <IconComponent size={24} />
        </div>

        <h3
          style={{
            fontSize: '20px',
            fontFamily: 'var(--font-heading)',
            fontWeight: 800,
            color: 'var(--text-main)',
            marginBottom: '12px',
            textTransform: 'uppercase'
          }}
        >
          {item.title}
        </h3>

        <p
          style={{
            fontSize: '14px',
            lineHeight: '1.6',
            color: 'var(--text-muted)',
            marginBottom: '24px'
          }}
        >
          {item.description}
        </p>
      </div>

      <a
        href={generateGeneralWhatsAppLink(item.title)}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: '8px',
          color: 'var(--accent-magenta)',
          fontSize: '13px',
          fontWeight: 700,
          letterSpacing: '0.05em',
          textTransform: 'uppercase',
          marginTop: 'auto'
        }}
      >
        <span>ENQUIRE FOR {item.title}</span>
        <ArrowRight size={14} />
      </a>
    </motion.div>
  );
};

export default BuyerCard;
